module.exports = __webpack_public_path__ + "static/media/No-data-page.e88096f2.svg";